import { Component } from 'react';
import { connect } from 'react-redux';

import firebaseApp from './../../utils/firebase/firebase';

import * as historyActions from './historyActions';

export class History extends Component {

    componentDidMount = () => {
        firebaseApp.database().ref(`users/${ firebaseApp.auth().currentUser.uid }/history`).on('child_added', (snapshot) => {
            const { action, entity, created_at, points, value } = snapshot.val();
            const key = snapshot.key;
            this.props.dispatch( historyActions.retrieveHistory(key, action, entity, created_at, points, value) );
        });
    }

    /*
    componentWillUnmount = () => {
        firebaseApp.database().ref(`users/`).off();
    }*/

    
    render(){
        return null;
    }
}
  
export default connect( null )(History);



// WEBPACK FOOTER //
// ./src/components/History/History.js